<template>
  <div class="row-box">
    <WrapperField
      v-for="(fieldValue, fieldName) in orderedDetails"
      :key="fieldValue + fieldName + Math.random()"
      :data="
        createDataField({
          fieldName,
          fieldValue,
          fieldGroup: FieldGroup.BANK_DETAILS,
        })
      "
    />
  </div>
</template>

<script>
import WrapperField from '@/components/elements/statement/FullStatementView/base/WrapperField';
import { createDataField, FieldGroup } from '@/utils/fullStatementView';

const ORDERED_DETAILS = [
  'recipientName',
  'amount',
  'bankName',
  'accountNumber',
  'corrAccountNumber',
  'bic',
  'inn',
  'kpp',
];

export default {
  name: 'BankDetails',
  props: ['data'],
  components: {
    WrapperField,
  },
  data: () => ({
    FieldGroup,
    createDataField,
  }),
  computed: {
    orderedDetails() {
      const details = {};

      ORDERED_DETAILS.forEach((key) => {
        if (Object.prototype.hasOwnProperty.call(this.data, key)) {
          details[key] = this.data[key];
        }
      });

      return details;
    },
  },
};
</script>
